import { useState } from "react";
import * as XLSX from "xlsx";
import { Col, Form, Row } from "react-bootstrap";
import TitlePage from "../../../components/TitlePage";
import SubmitForm from "../../../components/SubmitForm";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import LoadingSpinner from "../../../components/LoadinSpinner";
import SelectEmpresa from "../../../components/Select/Empresa";
import InputGeral from "../../../components/InputGeral/Index";
import { ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";

const LiberaPedidoVenda = () => {
    const [carregar, setCarregar] = useState(false);
    const [empresa, setEmpresa] = useState({value: "",text: "", });
    const [pedido, setPedido] = useState("");
    const [produtos, setProdutos] = useState([]);
    

    const processarProdutos = async() => {
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''
        let consultaDefault = `SELECT C6_FILIAL FILIALPV, C6_NUM NUMEROPV, B1_COD PRODUTO, 'N' RASTRO, '' LOCALIZA FROM TABELA(SC6) SC6 
            INNER JOIN TABELA(SC9) SC9 ON C9_FILIAL = C6_FILIAL AND C9_CLIENTE = C6_CLI AND C9_LOJA = C6_LOJA AND C9_PEDIDO = C6_NUM AND C9_ITEM = C6_ITEM AND SC9.D_E_L_E_T_ <> '*'
            INNER JOIN TABELA(SB1) SB1 ON B1_COD = C6_PRODUTO AND B1_RASTRO = 'L' AND SB1.D_E_L_E_T_ <> '*'
            WHERE C6_FILIAL = '${empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)}'
            AND C6_NUM = '${pedido}'
            AND C9_QTDLIB > 0
            AND SC6.D_E_L_E_T_ <> '*'`
        
        let  retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, "SC6;SC9;SB1", empresaFilial );
        
        if (retConsulta.error === '00'){
            return retConsulta.data
        }

        return [];
    };

    const handleSubmit = async() => {
        setCarregar(true);
        const produtos = await processarProdutos();

        if (produtos.length > 0){
            const cJSON = JSON.stringify(produtos)
            const oRetorno = await ConsumoTOTVS_POST('AJUSTALIBERACAOPV', cJSON)

            if (oRetorno.error === '00'){
                SucessoMsg("Produto Atualizado para Liberação do Pedido.");

                //Dispara Thread para retornar o produto para o status de Rastro e Localizacao
                const prodRastro = produtos.map((item) => {
                    item.RASTRO = 'L'
                    item.LOCALIZA = 'S'   

					return item
                })

                const cJSON = JSON.stringify(prodRastro)
                const oRetorno = ConsumoTOTVS_POST('AJUSTALIBERACAOPV', cJSON)
            }else{
                ErroMsg(oRetorno.description)
            }
        }
        
        setCarregar(false);        
        
        return false
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Liberação de Produtos - Pedido de Venda" exibirIncluir={false}/>
                </Col>
            </Row>
            <Row>
                
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Numero Pedido Venda"
                        tipo='text'
                        max="6"
                        value={pedido}  // Define o valor do campo com base no estado
                        onChange={(e) => setPedido(e.target.value)}
                    />
                </Col>
            </Row>
            
            <SubmitForm 
                onEnviar={handleSubmit}
                labelEnviar="➤ Liberar"
            />
        </>
    );
};

export default LiberaPedidoVenda;